import { useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import colorSharp from "../assets/img/color-sharp.png";
import { AnimatedOnScroll } from './AnimatedOnScroll';

const frontendSkills = [
  { name: "HTML5", icon: "https://cdn.simpleicons.org/html5/E34F26" },
  { name: "CSS3", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
  { name: "Sass", icon: "https://cdn.simpleicons.org/sass/CC6699" },
  { name: "Tailwind CSS", icon: "https://cdn.simpleicons.org/tailwindcss/06B6D4" },
  { name: "JavaScript", icon: "https://cdn.simpleicons.org/javascript/F7DF1E" },
  { name: "TypeScript", icon: "https://cdn.simpleicons.org/typescript/3178C6" },
  { name: "React", icon: "https://cdn.simpleicons.org/react/61DAFB" },
  { name: "Vue", icon: "https://cdn.simpleicons.org/vuedotjs/4FC08D" },
  { name: "Angular", icon: "https://cdn.simpleicons.org/angular/DD0031" },
  { name: "Vite", icon: "https://cdn.simpleicons.org/vite/646CFF" },
  { name: "Git", icon: "https://cdn.simpleicons.org/git/F05032" },
  { name: "GitHub", icon: "https://cdn.simpleicons.org/github/181717" },
  { name: "Vercel", icon: "https://cdn.simpleicons.org/vercel/000000" },
];

const backendSkills = [
  { name: "Node.js", icon: "https://cdn.simpleicons.org/nodedotjs/339933" },
  { name: "PostgreSQL", icon: "https://cdn.simpleicons.org/postgresql/4169E1" },
  { name: "MySQL", icon: "https://cdn.simpleicons.org/mysql/4479A1" },
  { name: "MongoDB", icon: "https://cdn.simpleicons.org/mongodb/47A248" },
  { name: "Fastify", icon: "https://cdn.simpleicons.org/fastify/000000" },
  { name: "Prisma", icon: "https://cdn.simpleicons.org/prisma/2D3748" },
  { name: "Render", icon: "https://cdn.simpleicons.org/render/46E3B7" },
];

const LOGO_WIDTH = 80;
const GAP = 40;
const SCROLL_SPEED = 0.4;
const ARROW_JUMP = 180;

const SkillCarousel = ({ skills }) => {
  const trackRef = useRef(null);
  const positionRef = useRef(0);
  const halfTrackWidth = skills.length * (LOGO_WIDTH + GAP);

  useEffect(() => {
    let animationId;
    const animate = () => {
      positionRef.current += SCROLL_SPEED;
      if (positionRef.current >= halfTrackWidth) {
        positionRef.current -= halfTrackWidth;
      }
      if (trackRef.current) {
        trackRef.current.style.transform = `translateX(-${positionRef.current}px)`;
      }
      animationId = requestAnimationFrame(animate);
    };
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [halfTrackWidth]);

  const scrollLeft = () => {
    positionRef.current += ARROW_JUMP;
    if (positionRef.current >= halfTrackWidth) {
      positionRef.current -= halfTrackWidth;
    }
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${positionRef.current}px)`;
    }
  };

  const scrollRight = () => {
    positionRef.current -= ARROW_JUMP;
    if (positionRef.current < 0) {
      positionRef.current += halfTrackWidth;
    }
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${positionRef.current}px)`;
    }
  };

  return (
    <div className="skills-marquee-wrapper">
      <button
        type="button"
        className="skill-carousel-arrow skill-carousel-arrow-left"
        onClick={scrollRight}
        aria-label="Scroll right"
      >
        <ChevronLeft size={28} />
      </button>
      <div className="skills-marquee">
        <div ref={trackRef} className="skills-marquee-track">
          {[...skills, ...skills].map((skill, index) => (
            <div key={index} className="skill-logo-wrapper">
              <div className="skill-logo">
                <img src={skill.icon} alt={skill.name} />
                <span className="skill-logo-tooltip">{skill.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button
        type="button"
        className="skill-carousel-arrow skill-carousel-arrow-right"
        onClick={scrollLeft}
        aria-label="Scroll left"
      >
        <ChevronRight size={28} />
      </button>
    </div>
  );
};

export const Skills = () => {
  return (
    <section className="skill" id="skills">
      <Container className="card-section-container">
        <Row>
          <Col xs={12}>
            <AnimatedOnScroll animation="animate__fadeInUp" partialVisibility className="skill-bx">
              <h2 className="section-title">Skills</h2>
              <p>Technologies and tools I work with</p>

              <h3 className="skill-subtitle">Front-end</h3>
              <SkillCarousel skills={frontendSkills} />

              <h3 className="skill-subtitle">Back-end</h3>
              <SkillCarousel skills={backendSkills} />
            </AnimatedOnScroll>
          </Col>
        </Row>
      </Container>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};
